export type Viewport = 'mobile' | 'tablet' | 'desktop';

export type Status = 'PROVIDED' | 'NOT_PROVIDED' | 'SKIPPED' | 'UNKNOWN';

export interface DsUserInsights {
  storeName: { summary: string; status: string };
  businessOverview: { summary: string; status: string };
  storeLookAndFeel: { summary: string; status: string };
  contactDetails: { summary: string; status: string };
}

export enum DsBuilderMethod {
  CATEGORY_PAGE = 0,
  TEMPLATE_SELECTION = 1,
  STORE_NAME = 2,
  SITE_PREVIEW = 3,
  CHECKOUT = 4,
}
